import React from 'react'
import HomeContainer from '../components/Home/HomeContainer'


const Home = () => {
  return (
    <>
     
      <HomeContainer />
    </>
  )
}

export default Home